import largeVisionDevicesOnline from './largeVisionDevicesOnline'
import largeVisionDwellTimeline from './largeVisionDwellTimeline'
import largeVisionInteractionsPerPlaylist from './largeVisionInteractionsPerPlaylist'
import largeVisionInteractionsPerProduct, { largeVisionProductDetails } from './largeVisionInteractionsPerProduct'
import largeVisionInteractionsTotal from './largeVisionInteractionsTotal'
import largeVisionPlaylistTop from './largeVisionPlaylistTop'
import largeVisionSessionsTimeline from './largeVisionSessionsTimeline'
import largeVisionStoresTop from './largeVisionStoresTop'

const largeVisionReducers = [
    largeVisionDevicesOnline,
    largeVisionDwellTimeline,
    largeVisionInteractionsPerPlaylist,
    largeVisionInteractionsPerProduct,
    largeVisionProductDetails,
    largeVisionInteractionsTotal,
    largeVisionPlaylistTop,
    largeVisionSessionsTimeline,
    largeVisionStoresTop,
]

export default largeVisionReducers
